import React, { useState, useEffect } from "react";
import BASE_URL from "components/BaseUrl/apiConfig";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AnimatedCard from 'react-animated-3d-card';
import CardStats from "components/Cards/CardStats.js";

export default function HeaderStats() {


  const quantityTracking = "https://img.freepik.com/free-vector/hand-drawn-flat-design-delivery-concept_23-2149180380.jpg?t=st=1711948462~exp=1711952062~hmac=45b8650d76037062e06715cf8f434995ea0a6b2573f6fc49804e65ba94d54c3e&w=900";

  const imageExpenseTracking = 'https://img.freepik.com/free-vector/concept-credit-card-payment-landing-page_52683-24923.jpg?1&w=740&t=st=1711947447~exp=1711948047~hmac=1ff4970dfbe41a24d13c7431bf74a53633afed133e0617f01f11d41c3f00ef7e';

  const notesimage = "https://img.freepik.com/free-vector/add-notes-concept-illustration_114360-2496.jpg?t=st=1711948128~exp=1711951728~hmac=e96b7483cd0310a90c37cd678fd29999d4e5cba0726d934569ae4169785b8ed4&w=740";

  const documentimg = "https://img.freepik.com/premium-vector/birdcages-icon-decoration-object-vintage-concept-vector-graph_24911-38489.jpg?w=740";

  const history = useHistory(); // Get the history object
  const [currency, setCurrency] = useState("");
  const [totalBalance, setTotalBalance] = useState([]);

  //get userid form loca storage
  const storedUserData = localStorage.getItem('userData');
  let userId = '';
  let groupId = '';
  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
  }

  //Get all exepense type data 
  useEffect(() => {
    const fetchExpenseTypes = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Expense/GetTotalBalance?groupId=${groupId}`
        );
        const data = await response.json();
        console.log(data);
        setTotalBalance(data);

        // console.log(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchExpenseTypes();
  }, []);



  useEffect(() => {
    const fetchCurrencyData = async () => {
      try {
        debugger
        const response = await fetch(`${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`);
        const data = await response.json();
        // Assuming the API response has a property called 'currency'
        setCurrency(data.currency);
        console.log(data);

      } catch (error) {
        console.error("Error fetching currency data:", error);
      } finally {

      }
    };

    fetchCurrencyData();
  }, []); // The empty dependency array ensures that this effect runs only once when the component mounts



  // Check if availableBalance is greater than 0
  const isPositiveBalance = totalBalance.availableBalance > 0;

  // Set the color dynamically based on the condition
  const balanceColor = isPositiveBalance ? 'rgb(0, 0, 255)' : 'red';


  const OnQuantityTrackingClick = () => {
    history.push('/getQuantityTraking');
  }

  const OnExpenseTrackingClick = () => {
    history.push('/expenses');
  }

  const OnNotesClick = () => {
    history.push('/notes');
  }

  const getDocument = () => {
    history.push('/getDocument');
  }


  return (
    <>
      {/* Header */}

      <div className="relative  ">
        <div className=" mx-auto w-full">
          <div>
            {/* Card stats */}
            <div className="flex flex-wrap">

              <div className="w-full lg:w-6/12 xl:w-3/12  p-4">
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={OnExpenseTrackingClick}>
                  <AnimatedCard
                    config={{
                      rotation: 30, // Initial rotation of the card (in degrees)
                      transformSpeed: 1000, // Speed of the card transformation (in milliseconds)
                      transitionSpeed: 600 // Speed of the card's transitions (in milliseconds)
                    }}
                  >
                    <div style={{ width: '285px', height: '200px', color: 'white', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                      <img src={imageExpenseTracking} alt="ExpenseTracking" style={{ width: '100%', height: 'auto' }} />
                    </div>
                    <h2 class="text-blueGray-700 text-xl font-semibold text-center mb-2" > Expense Management</h2>
                  </AnimatedCard>
                </div>

              </div>

              <div className="w-full lg:w-6/12 xl:w-3/12 p-4">
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={OnQuantityTrackingClick}>
                  <AnimatedCard
                    config={{
                      rotation: 30, // Initial rotation of the card (in degrees)
                      transformSpeed: 1000, // Speed of the card transformation (in milliseconds)
                      transitionSpeed: 600 // Speed of the card's transitions (in milliseconds)
                    }}
                  >
                    <div style={{ width: '285px', height: '200px', color: 'white', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                      <img src={quantityTracking} alt="Quantity Tracking" style={{ width: '100%', height: 'auto' }} />
                    </div>
                    <h2 class="text-blueGray-700 text-xl font-semibold text-center mb-2" > Quantity Management</h2>
                  </AnimatedCard>
                </div>

              </div>
              <div className="w-full lg:w-6/12 xl:w-3/12 p-4">
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={OnNotesClick}>
                  <AnimatedCard
                    config={{
                      rotation: 30, // Initial rotation of the card (in degrees)
                      transformSpeed: 1000, // Speed of the card transformation (in milliseconds)
                      transitionSpeed: 600 // Speed of the card's transitions (in milliseconds)
                    }}
                  >
                    <div style={{ width: '285px', height: '200px', color: 'white', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                      <img src={notesimage} alt="Your Image" style={{ width: '100%', height: 'auto' }} />
                    </div>
                    <h2 class="text-blueGray-700 text-xl font-semibold text-center mb-2"  > Notes</h2>
                  </AnimatedCard>
                </div>

              </div>
              <div className="w-full lg:w-6/12 xl:w-3/12 p-4">
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} onClick={getDocument}>
                  <AnimatedCard
                    config={{
                      rotation: 30, // Initial rotation of the card (in degrees)
                      transformSpeed: 1000, // Speed of the card transformation (in milliseconds)
                      transitionSpeed: 600 // Speed of the card's transitions (in milliseconds)
                    }}
                  >
                    <div style={{ width: '285px', height: '200px', color: 'white', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                      <img src={documentimg} alt="Your Image" style={{ width: '100%', height: 'auto' }} />
                    </div>
                    <h2 class="text-blueGray-700 text-xl font-semibold text-center mb-2">Documents Management</h2>
                  </AnimatedCard>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative md:pt-8 pb-16 mt-4">
        <div className=" mx-auto w-full">
          {/* Card stats */}
          <div className="flex flex-wrap">

            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
              <CardStats
                statSubtitle="Available Balance"
                statTitle={totalBalance.availableBalance}
                currency={currency}
                statPercentColor="text-emerald-500"
                statIconName="fas fa-balance-scale"
                statIconColor="bg-red-500"
              />
            </div>
            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
              <CardStats
                statSubtitle="Total Credited"
                statTitle={totalBalance.totalCreatedSum}
                currency={currency}
                statPercentColor="text-orange-500"
                statIconName="fas fa-balance-scale"
                statIconColor="bg-orange-500"
              />
            </div>
            <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
              <CardStats
                statSubtitle="Total Debited"
                statTitle={totalBalance.totalDebitedSum}
                currency={currency}
                statPercentColor="text-red-500"
                statIconName="fas fa-balance-scale"
                statIconColor="bg-pink-500"
              />
            </div>

          </div>
        </div>
      </div>
    </>
  );
}
